<script>
export default {
    methods: {
        back() {
            this.$router.go(-1)
        },
    },
}
</script>

<template lang="pug">
v-btn(@click="back" outlined)
    v-icon(left) arrow_back
    | {{ $t('actions.back') }}

</template>

<style scoped lang="scss"></style>
